var _slicedToArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectSpread = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _defineProperty = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var Assert = require('assert');

var Joi = require('@hapi/joi');

var EscapeHtml = require('escape-html');

var get = require('lodash.get');

var _require = require('./schema'),
    middlewareSchema = _require.middlewareSchema,
    celebrateSchema = _require.celebrateSchema,
    sourceSchema = _require.sourceSchema,
    optSchema = _require.optSchema;

var CELEBRATED = Symbol('celebrated');
var DEFAULT_JOI_OPTIONS = {
  escapeHtml: true
};
var DEFAULT_FORMAT_OPTIONS = {
  celebrated: true
};

var _format = function _format(error, source, opts) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, CELEBRATED, opts.celebrated), _defineProperty(_ref, "joi", error), _defineProperty(_ref, "meta", {
    source: source
  }), _ref;
};

var format = function format(err, source) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    celebrated: false
  };
  Assert.ok(get(err, 'error.isJoi', false));
  var result = Joi.validate(source, sourceSchema);
  Assert.ifError(result.error);
  result = Joi.validate(opts, optSchema);
  Assert.ifError(result.error);
  var error = err.error;
  return _format(error, source, opts);
};

var validateSource = function validateSource(source) {
  return function (_ref2) {
    var celebrateOpts = _ref2.celebrateOpts,
        joiOpts = _ref2.joiOpts,
        req = _ref2.req,
        rules = _ref2.rules;
    var spec = rules.get(source);

    if (!spec) {
      return null;
    }

    var result = Joi.validate(req[source], spec, celebrateOpts.reqContext ? _objectSpread(_objectSpread({}, joiOpts), {}, {
      context: req
    }) : joiOpts);
    var value = result.value,
        error = result.error;

    if (value !== undefined) {
      Object.defineProperty(req, source, {
        value: value
      });
    }

    if (error) {
      return _format(error, source, DEFAULT_FORMAT_OPTIONS);
    }

    return null;
  };
};

var validateHeaders = validateSource('headers');
var validateParams = validateSource('params');
var validateQuery = validateSource('query');
var validateCookies = validateSource('cookies');
var validateSignedCookies = validateSource('signedCookies');
var validateBody = validateSource('body');

var maybeValidateBody = function maybeValidateBody(config, callback) {
  var method = config.req.method.toLowerCase();

  if (method === 'get' || method === 'head') {
    return null;
  }

  return validateBody(config, callback);
};

var REQ_VALIDATIONS = [validateHeaders, validateParams, validateQuery, validateCookies, validateSignedCookies, maybeValidateBody];

var isCelebrate = function isCelebrate(err) {
  if (err != null && typeof err === 'object') {
    return err[CELEBRATED] || false;
  }

  return false;
};

var celebrate = function celebrate(schema) {
  var joiOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var celebrateOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result = Joi.validate(schema, middlewareSchema);
  Assert.ifError(result.error);
  result = Joi.validate(celebrateOptions, celebrateSchema);
  Assert.ifError(result.error);
  var rules = new Map();

  var joiOpts = _objectSpread(_objectSpread({}, DEFAULT_JOI_OPTIONS), joiOptions);

  Object.entries(schema).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    return rules.set(key, Joi.compile(value));
  });

  var middleware = function middleware(req, res, next) {
    var stepNumber = 0;
    var err = null;
    var config = {
      req: req,
      joiOpts: joiOpts,
      rules: rules,
      celebrateOpts: celebrateOptions
    };

    do {
      var step = REQ_VALIDATIONS[stepNumber];
      err = step(config);
      stepNumber += 1;
    } while (stepNumber <= REQ_VALIDATIONS.length - 1 && err === null);

    next(err);
  };

  middleware._schema = schema;
  return middleware;
};

var errors = function errors() {
  return function (err, req, res, next) {
    // If this isn't a Celebrate error, send it to the next error handler
    if (!isCelebrate(err)) {
      return next(err);
    }

    var joi = err.joi,
        meta = err.meta;
    var result = {
      statusCode: 400,
      error: 'Bad Request',
      message: joi.message,
      validation: {
        source: meta.source,
        keys: []
      }
    };

    if (joi.details) {
      for (var i = 0; i < joi.details.length; i += 1) {
        var path = joi.details[i].path.join('.');
        result.validation.keys.push(EscapeHtml(path));
      }
    }

    return res.status(400).send(result);
  };
};

module.exports = {
  celebrate: celebrate,
  errors: errors,
  Joi: Joi,
  isCelebrate: isCelebrate,
  format: format
};